import { fetchApi } from 'api/index'
import { NodeHeaders } from 'api/NodeHeaders'

export const fetchAllowedVerificationApi = (headers?: NodeHeaders) =>
  fetchApi('/real_user/allowed_methods', { headers })
